var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    class: _vm.className,
    attrs: {
      "visual": _vm.title
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('search', {
    on: {
      "search": function search($event) {
        return _vm.search();
      },
      "clickArea": _vm.toggleShowArea
    },
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  }), _c('filter-areas', {
    attrs: {
      "areas": _vm.areas,
      "areas_manual": _vm.areas_manual,
      "showArea": _vm.showArea
    },
    on: {
      "close": _vm.toggleShowArea
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _vm._l(_vm.experts, function (expert) {
    return _c('list-item', {
      key: expert._id,
      attrs: {
        "expert": expert
      }
    });
  }), _c('pagination-component', {
    attrs: {
      "count": _vm.pageCount
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }